export default __webpack_public_path__ + "images/Roka-Kandal-Chas-Interior-of-Buddhist-sanctuary.webp";